import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _ from 'lodash';
/**
 * Generate action creators from given model
 * @param  {class} model
 * @return {object}
 */

function coreGenerateActionCreators(model) {
  return function (dispatch) {
    var actionCreators = model.actionCreators;
    var actions = {};

    var _loop = function _loop(key) {
      var action = actionCreators[key];

      actions[key] = function (payload) {
        var actionResult = action(payload); // NOTE: we can dispatch both sync and async actions directly here,
        //  redux thunk takes care of everthing!

        return dispatch(actionResult);
      };
    };

    for (var key in actionCreators) {
      _loop(key);
    }

    return actions;
  };
}
/**
 * Memoized version of `coreGeneratorActionCreators`
 */


export var generateActionCreators = _.memoize(coreGenerateActionCreators, function (model) {
  var _context;

  return _concatInstanceProperty(_context = "".concat(model.namespace, "/")).call(_context, model.modelName);
});
/**
 * Generate combined selectors function (for redux connects) from given model
 * @param  {class} model
 * @return {function}
 */

export function generateSelectors(model) {
  return function (state, props) {
    var selectors = {};
    selectors[model.namespace || model.modelName] = model.selectors(state, props);
    return selectors;
  };
}
/**
 * Deep merges props for react-redux connect decorator
 * NOTE: we avoid it in our HoCs since it will create a new props reference every time!
 * @param  {Object} stateProps
 * @param  {Object} dispatchProps
 * @param  {Object} ownProps
 * @return {Object}
 */

export function mergeProps(stateProps, dispatchProps, ownProps, namespace) {
  if (namespace) {
    return _objectSpread(_objectSpread({}, ownProps), {}, _defineProperty({}, namespace, _objectSpread(_objectSpread(_objectSpread({}, ownProps[namespace] || {}), stateProps[namespace]), dispatchProps[namespace])));
  } // NOTE: this is BAD!, but the old @rexlabs/form relies on it :(


  return _.merge({}, ownProps, stateProps, dispatchProps);
}